<template>
	<BasePublishPostsWidget :fetch="postsConfig" thumb-preset="publishEntry" v-slot="{items}">
		<div class="pp-speciallist" v-if="items?.length">
			<div class="wrapper">
				<div class="pp-speciallist-cnt">
					<div class="pp-speciallist-title">{{ labels.get('top_articles') }}</div>
					<div class="pp-speciallist-slider">
						<BaseUiSwiper name="special-posts" :options="specialPostsSliderOptions">
							<BaseUiSwiperSlide v-for="specialPost in items" :key="specialPost.id">
								<PublishIndexEntry :item="specialPost" :short-description="true" mode="small" />
							</BaseUiSwiperSlide>
						</BaseUiSwiper>
					</div>
				</div>
			</div>
		</div>
	</BasePublishPostsWidget>
</template>

<script setup>
	const labels = useLabels();

	const postsConfig = {
		list_code: ['top_articles'],
		limit: 12,
		extra_fields: ['short_description'],
		sort: 'list_position',
	};

	// slider config
	const specialPostsSliderOptions = {
		slidesPerView: 3,
		slidesPerGroup: 3,
		spaceBetween: 0,
		breakpoints: {
			0: {
				slidesPerView: 1,
				slidesPerGroup: 1,
				spaceBetween: 0,
			},
			760: {
				slidesPerView: 3,
				slidesPerGroup: 3,
				spaceBetween: 10,
			},
		},
	};
</script>

<style lang="less">
	.pp-fallback{
		display: flex;
		.pp{margin-top: 30px;}
		.pp:not(:nth-child(-n+3)){display: none;}

		@media (max-width: @ms){
			.pp{margin-top: 13px;}
			.pp:not(:nth-child(-n+3)){display: flex;}
			.pp:not(:nth-child(-n+1)){display: none;}
		}
	}
	.pp-speciallist {
		background: #f0f2f4; padding: 60px 0 30px; @media (max-width: @t) {
			padding: 40px 0 30px;
		}
		@media (max-width: @m) {
			padding: 30px 0 15px;
		}
		@media (max-width: @ms) {
			padding: 20px 0;
		}
	}
	.pp-speciallist-title {
		font: 36px/1.2 @font; letter-spacing: -0.75px; @media (max-width: @t) {
			font-size: 30px; letter-spacing: -0.6px; }
		@media (max-width: @m) {
			font-size: 28px;
		}
		@media (max-width: @ms) {
			font-size: 20px; line-height: 24px; letter-spacing: -0.41px;
		}
	}
	.pp-speciallist-slider {
		position: relative;
		&:before,
		&:after {
			.pseudo(10px,auto); z-index: 1; left: 0; top: 0; bottom: 0; }
		&:after {
			left: unset; right: 0; }
		@media (max-width: @t) { width: 100%; margin: 0; }
		.swiper{
			padding: 15px 10px; margin: 0 -15px;
			@media (max-width: @t){padding: 0; margin: 15px 0 0 0;}
		}
		.swiper-wrapper { display: flex; }
		.swiper-button {
			top: 140px;
			@media (max-width: @l) {
				top: 120px;
			}
			@media (max-width: @t) {
				width: 44px; height: 44px; background: @white; transform: none; top: 72px; left: -14px; box-shadow: 0 10px 30px 0 rgba(1, 61, 112, 0.15);
			}
			@media (max-width: @m) {
				width: 35px; height: 35px; top: 59px;
			}
			@media (max-width: @ms) {
				width: 30px; height: 30px; top: calc(~'(100vw - 30px) / 5'); box-shadow: 0 2px 30px 0 rgba(0, 37, 69, 0.4);
			}
			&:before {
				@media (max-width: @t) {
					font: 16px/16px @fonti;
				}
				@media (max-width: @m) {
					font: 14px/15px @fonti;
				}
				@media (max-width: @ms) {
					font: 11px/12px @fonti;
				}
			}
		}
		.splide__arrow--prev, .swiper-button-prev {
			@media (max-width: @ms) {
				left: -13px;
			}
		}
		.splide__arrow--next, .swiper-button-next {
			@media (max-width: @t) {
				left: unset; .rotate(180deg);
			}
			@media (max-width: @ms) {
				right: -13px;
			}
		}
		.pp {
			display: flex !important; height: auto; margin: 0; background: transparent; width: auto;
			&:hover {
				background: @white; box-shadow: 0 8px 10px 0 rgba(1, 61, 112, 0.15); @media (max-width: @t) {
					background: transparent; box-shadow: none;
				}
			}
			@media (max-width: @ms) {
				.pp-short-desc {
					display: block; padding-top: 5px; }
			}
		}
	}
</style>
